<template>
  <div>
    <scroll-bar>
      <el-menu
        mode="vertical"
        unique-opened
        :default-active="$route.meta.active || $route.path"
        :collapse="isCollapse"
        background-color="#363636"
        text-color="#fff"
        active-text-color="#fff"
      >
        <sidebar-item :routes="routes || []"></sidebar-item>
      </el-menu>
    </scroll-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters(['sidebar']),
    routes() {
      console.log('this.$store.getters.menuData', this.$store.getters.menuData)
      return this.$store.getters.menuData
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue